import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { log } from "./utils";
// CSS & Themes
import "./assets/css/default.css";
import { grey } from '@mui/material/colors';

// Layouts
import { AppLayout } from "./layouts/AppLayout";

// Pages
import { Login } from "./pages/Login";
import WarehouseView from "./pages/WarehouseView";
import DataLayout from "./layouts/DataLayout";

import ProtectedRoute from "./components/ProtectedRoute";

// Contexts
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './DataContext';

// Theme
import { createTheme, ThemeProvider } from '@mui/material';

let theme = createTheme({
    // Theme customization goes here as usual, including tonalOffset and/or
    // contrastThreshold as the augmentColor() function relies on these
});

theme = createTheme(theme, {
    palette: {
        primary: theme.palette.augmentColor({
            color: {
                main: '#00A49B',
            },
            name: 'primary',
        }),
        grey: theme.palette.augmentColor({
            color: {
              main: grey[500],
            },
            name: 'grey',
        }),
        lightergrey: theme.palette.augmentColor({
            color: {
              main: grey[200],
            },
            name: 'lightergrey',
        }),
        persiangreen: theme.palette.augmentColor({
            color: {
              main: '#00A49B',
            },
            name: 'persiangreen',
        }),
        tarawera: theme.palette.augmentColor({
            color: {
              main: '#063852',
            },
            name: 'tarawera',
        }),
    },
});

function App() {
    try {
        return (
            <ThemeProvider theme={theme}>
                <AuthProvider>
                    <Router>
                        <Routes>
                            {/* Protected Routes */}
                            <Route element={<ProtectedRoute />}>
                                <Route element={<DataProvider><DataLayout /></DataProvider>}>
                                    <Route path="/" element={<AppLayout />}>
                                        <Route path="" element={<WarehouseView />} />
                                    </Route>
                                </Route>
                            </Route>
                            
                            {/* Public Routes */}
                            <Route path="/login" element={<Login />} />

                            <Route path="*" element={<div>404 Not Found</div>} />
                        </Routes>
                    </Router>
                </AuthProvider>
            </ThemeProvider>
        );
    } catch (error) {
        log("error", "App.js", 0, "Error: " + error.message, error.stack);
    }
}

export default App;
